import { useTranslations } from '@vocab/react';
import {
  StarSelector,
  type Rating,
} from '../../components/StarSelector/StarSelector';
import type { QuestionProps } from '../../type';
import translations from './.vocab';

export const CareerOpportunityRatingQuestion = (
  props: QuestionProps<Rating>,
) => {
  const { t } = useTranslations(translations);
  return (
    <StarSelector
      id="careerOpportunityRating"
      {...props}
      title={t('Career development opportunities')}
    />
  );
};
